/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetModelsHierarchyResult } from '../../models/get-models-hierarchy-result';

export interface ApiModelsHierarchyGet$Params {
  modelTypeId?: string;
  includeAll?: boolean;
  hostingLocaleId?: string;
}

export function apiModelsHierarchyGet(http: HttpClient, rootUrl: string, params?: ApiModelsHierarchyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetModelsHierarchyResult>> {
  const rb = new RequestBuilder(rootUrl, apiModelsHierarchyGet.PATH, 'get');
  if (params) {
    rb.query('modelTypeId', params.modelTypeId, {});
    rb.query('includeAll', params.includeAll, {});
    rb.query('hostingLocaleId', params.hostingLocaleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetModelsHierarchyResult>;
    })
  );
}

apiModelsHierarchyGet.PATH = '/api/Models/hierarchy';
